// Static, always-available virtual-background options for the consultant
// self-view. These two are not stored in the database or S3:
//   - "none" simply disables the effect (raw camera).
//   - "blur" is handled entirely by the Agora extension.
//
// Image backgrounds (system defaults + the user's own uploads) are now fetched
// from the backend (GET /api/virtual-backgrounds) and stored in S3, so they are
// no longer bundled here.

const STATIC_VIRTUAL_BACKGROUNDS = [
  { id: "none", label: "None", type: "none" },
  { id: "blur", label: "Blur", type: "blur", blurDegree: 2 },
];

export default STATIC_VIRTUAL_BACKGROUNDS;
